// 记录「本次已上传、但可能还没保存」的图片 URL。
// 图片是选中即上传（el-upload 的 http-request），若表单没保存就关掉弹窗，
// 文件会变成服务器上的孤儿。弹窗关闭时统一调用 discardUploads()：
// 后端只删「全库无引用」的图，所以已保存的会被保留，未保存的才会被清掉。
import { cleanupUploads } from '../api'

const pending = new Set()

// 上传成功后登记该 URL
export function trackUpload(url) {
  if (url) pending.add(url)
}

// 弹窗关闭时调用：一次性把登记过的 URL 交给后端做「无引用才删」的清理
export function discardUploads() {
  if (!pending.size) return
  const urls = Array.from(pending)
  pending.clear()
  cleanupUploads(urls).catch(() => {})
}
